module.exports = __webpack_public_path__ + "img/tabler_download.d8534c64.png";